// extracted by mini-css-extract-plugin
export default {"draggableContainer":"styles_draggableContainer__PUEBP","dragIcon":"styles_dragIcon__3nCEg","activeItem":"styles_activeItem__TpiDD"};